import React, { useState, useEffect, useRef } from 'react';
import { appointmentStatusToString, appointmentStatusAvatarStyle, appointmentStatusToIcon, formatDate } from '../helpers/Helpers';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { SERVER_URL } from '../constants';
import CommonSnackbar from './CommonSnackbar';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import dayjs from 'dayjs';
import BasicTimePicker from './BasicTimePicker';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));

function OfficeTodaysFixedScheduleTimeChange (props) {

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open || props.openTimeChangeModal) {
            handleOpen();
        }
    }, [open, props.openTimeChangeModal]); // runs whenever open state changes

    const handleOpen = () => {
        setSelectedTime(dayjs(props.customerAppointment.time, "HH:mm:ss"));
        setDisableSaveButton(true);
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        props.setOpenTimeChangeModal(false);
        setOpen(false);
    };

    const [errorTitle, setErrorTitle] = useState("");

    const [errorMessage, setErrorMessage] = useState("");

    const [selectedTime, setSelectedTime] = useState(dayjs(props.customerAppointment.time, "HH:mm:ss"));

    const snackbar = {
        errorTitle,
        errorMessage,
        setErrorTitle,
        setErrorMessage
    }

    const [saving, setSaving] = useState(false);

    const [disableSaveButton, setDisableSaveButton] = useState(true);

    const handleChange = (event) => {
        console.log("event", event);
        setSelectedTime(event);
        setDisableSaveButton(false);
    }

    const handleConfirm = () => {
        updateTime();
    }

    const updateTime = () => {
        console.log("selectedTime ", selectedTime.format('HH:mm:ss'));
        console.log("props.customerAppointment.time_slot_id ", props.customerAppointment.time_slot_id);
        setSaving(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/update-timeslot-time',
        {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "id" : props.customerAppointment.time_slot_id,
                "time" : selectedTime.format('HH:mm:ss')
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                // console.log("message", data.message);
                props.fetchTimeSlotList();
                // props.fetchOffices();
                handleClose();
                setErrorTitle("Message");
                setErrorMessage(data.message);
            }
            else {
                console.log("error", data.message);
                setErrorTitle("Error");
                setErrorMessage(data.message);
            }
            setSaving(false);
        })
        .catch(err => console.error(err))
    }
 
    return (
        <React.Fragment>
            <CommonSnackbar snackbar={snackbar} />

            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",  // Set your width here
                    },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open || props.openTimeChangeModal}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                        spacing={0}
                        >
                            <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                                Update Time
                            </Typography>
                            <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                                {props.customerAppointment.name}
                            </Typography>
                            <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                                status: {appointmentStatusToString(props.customerAppointment.status)}<br />
                            </Typography>
                        </Stack>
                    </DialogTitle>
                    
                    <DialogContent sx={{ m: 0, p: 2 }} dividers={true}>
                        <Stack spacing={2} padding={2}>
                            <BasicTimePicker 
                                value={selectedTime} 
                                onChange={handleChange} 
                                label="Select Time" 
                                ampm={true} 
                                minutesStep={5} 
                            />
                        </Stack>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            disabled={disableSaveButton || saving}
                            onClick={handleConfirm} 
                        >
                            Save
                        </Button>
                    </DialogActions>
                </BootstrapDialog>
        </React.Fragment>
      );
}

export default OfficeTodaysFixedScheduleTimeChange;